import { combineReducers } from "@reduxjs/toolkit";

import { loadingReducer } from "./common.slice";
import { userReducer } from "@/modules/user/reducer/user.slice";
import { meetingFormReducer } from "@/modules/meetings/reducer/meetingForm.slice";

export const rootReducer = combineReducers({
  common: loadingReducer,
  user: userReducer,
  meetingForm: meetingFormReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
